<template>
  <v-card class="elevation-1 mb-6 rounded-lg mt-0">
    <v-card-title class="pa-7">
      Přílohy
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        height="40px"
        min-width="130px"
        depressed
        @click.prevent="openUploadDialog()"
      >
        Nahrát přílohu
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="orderHeadersByRole"
        :items="attachment.items"
        :options.sync="attachment.options"
        :server-items-length="attachment.serverItemsLength"
        :loading="attachment.loading"
        item-key="id"
        class="elevation-0"
      >
        <template v-slot:item.createdAt="{ item }">
          <DateTime :single-line="false" :datetime="item.createdAt" />
        </template>
        <template v-slot:item.size="{ item }">
          <div style="max-width: 300px; padding-top: 5px; padding-bottom: 5px">
            {{ item.size + ' MB' }}
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn-toggle color="primary" dense group>
            <v-btn color="blue-grey" text @click.prevent="downloadAttachment($event, item.uuid)">
              <v-icon>mdi-download</v-icon>
            </v-btn>
            <v-btn color="blue-grey" text @click.prevent="deleteAttachments($event, item.uuid)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-btn-toggle>
        </template>
      </v-data-table>
    </v-card-text>
    <OrderAttachmentUploadDialog @attachmentUploaded="attachmentUploaded()" />
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { setFilters } from '@/components/mixins/setFilters'
import DateTime from '@/components/DateTime'
import OrderAttachmentUploadDialog from '@/components/order/OrderAttachmentUploadDialog'
import { downloadFile } from '@/components/mixins/downloadFile'

export default {
  name: 'OrderAttachments',
  components: {
    OrderAttachmentUploadDialog,
    DateTime,
  },
  mixins: [setFilters, downloadFile],
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      attachment: {
        headers: [
          {
            text: 'Datum',
            value: 'createdAt',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Uživatel',
            value: 'createdBy',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Název',
            value: 'name',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Název souboru',
            value: 'fileName',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Velikost',
            value: 'size',
            align: 'right',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: '',
            value: 'actions',
            width: '1px',
            sortable: false,
            roles: ['ROLE_ADMIN'],
          },
        ],
        items: [],
        options: {
          page: 1,
          itemsPerPage: 5,
          sortBy: ['id'],
          sortDesc: [true],
        },
        loading: false,
        serverItemsLength: 0,
      },
      attachmentFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    }
  },
  computed: {
    ...mapState({
      authorities: (state) => state.auth.user.authorities,
    }),
    orderHeadersByRole() {
      return this.attachment.headers.filter((e) =>
        e.roles.some((e) => this.authorities.includes(e))
      )
    },
  },
  watch: {
    status: {
      handler() {
        this.loadAttachments()
      },
    },
    'attachment.options': {
      handler() {
        this.loadAttachments()
      },
    },
    '$route.query': {
      handler() {
        this.loadAttachments()
      },
    },
  },
  methods: {
    ...mapActions({
      searchAttachments: 'order/searchOrderAttachments',
      deleteAttachment: 'order/deleteOrderAttachment',
    }),
    loadAttachments() {
      this.attachment.loading = true
      const searchParams = {
        options: this.attachment.options,
      }
      this.searchAttachments({ id: this.id, params: searchParams })
        .then((response) => {
          this.attachmentFooter.totalElements = response.data.totalElements
          this.attachment.items = response.data.items
          this.attachment.serverItemsLength = response.data.totalElements
          this.cancel = null
        })
        .finally(() => {
          this.attachment.loading = false
        })
    },
    deleteAttachments(event, uuid) {
      this.$confirm('', {
        title: 'Odebrat přílohu?',
        buttonTrueText: 'Ano',
        buttonFalseText: 'Ne',
        icon: '',
        color: 'black',
      }).then((result) => {
        if (result) {
          this.deleteAttachment({ id: this.id, uuid: uuid }).finally(() => {
            this.loadAttachments()
          })
        }
      })
    },
    downloadAttachment(event, uuid) {
      this.downloadFile(event, `upload/${uuid}`)
    },
    openUploadDialog() {
      this.$eventBus.$emit('uploadAttachmentDialog', true)
    },
    attachmentUploaded() {
      this.loadAttachments()
    },
    setFiltersAction(filters) {
      this.attachment.options.page = 1
      this.setFilters(filters)
    },
  },
}
</script>
